import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { FavouriteIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
};

const FavouriteThemedIcon = ({ className, width, height, theme }) => (
  <FavouriteIcon className={className} width={width} height={height} fill={theme.color.favourites} />
);

FavouriteThemedIcon.propTypes = propTypes;

export default withTheme(FavouriteThemedIcon);
